<template>
  <section class="app-footer">
    <!-- Background Upload Status -->
    <div v-if="photoUploads.length > 0" class="upload-status-bar bg-dark text-white p-2">
      <div class="container-fluid d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div v-if="activeUploads.length > 0" class="mr-3">
            <i class="mdi mdi-loading mdi-spin text-primary"></i>
            Uploading {{ activeUploads.length }} photo(s)...
          </div>
          <div v-if="errorUploads.length > 0" class="text-danger">
            <i class="mdi mdi-alert-circle"></i>
            {{ errorUploads.length }} upload(s) failed
            <button class="btn btn-xs btn-link text-danger p-0 ml-2" @click="retryAllErrors">Retry All</button>
          </div>
          <div v-if="activeUploads.length === 0 && errorUploads.length === 0 && successCount > 0" class="text-success">
            <i class="mdi mdi-check-circle"></i>
            All uploads complete
          </div>
        </div>
        <div>
          <button class="btn btn-xs btn-outline-light" @click="showUploadDetails = !showUploadDetails">
            {{ showUploadDetails ? 'Hide' : 'Details' }}
          </button>
        </div>
      </div>
      
      <!-- Detailed Queue -->
      <div v-if="showUploadDetails" class="upload-details mt-2 border-top border-secondary pt-2">
        <div class="container-fluid">
          <div v-for="upload in photoUploads" :key="upload.id" class="d-flex justify-content-between align-items-center mb-1 small">
            <div class="text-truncate mr-2" style="max-width: 200px;">
              {{ upload.fileName }}
            </div>
            <div class="flex-grow-1 mx-2">
              <div v-if="upload.status === 'uploading'" class="progress progress-xs">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <span v-if="upload.status === 'success'" class="text-success"><i class="mdi mdi-check"></i></span>
              <span v-if="upload.status === 'error'" class="text-danger" v-b-tooltip.hover.lefttop :title="upload.error">
                <i class="mdi mdi-alert-circle"></i>
                <button class="btn btn-xs btn-link text-white p-0 ml-1" @click="retryUpload(upload.id)"><i class="mdi mdi-refresh"></i></button>
              </span>
              <button class="btn btn-xs btn-link text-white p-0 ml-2" @click="removeUpload(upload.id)"><i class="mdi mdi-close"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">
          Copyright © {{ thisYear }}
          <a href="http://www.vernet.com.au/" target="_blank">VERNet</a>.
          All rights reserved.
        </span>
        <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
          Version #{{ version_data }} | <a href="https://docs.api.vernet.net.au/" target="_blank">API Documentation</a>
        </span>
      </div>
    </footer>
  </section>
</template>

<script>

const now = new Date();

export default {
  name: "app-footer",
  computed: {
    thisYear(){
      return now.getFullYear()
    },
    photoUploads() {
      return this.$store.getters.getPhotoUploads;
    },
    activeUploads() {
      return this.$store.getters.getActivePhotoUploads;
    },
    errorUploads() {
      return this.$store.getters.getErrorPhotoUploads;
    },
    successCount() {
      return this.photoUploads.filter(p => p.status === 'success').length;
    }
  },
  data: function () {
    return {
      version_data: process.env.VUE_APP_GIT_HASH,
      showUploadDetails: false
    }
  },
  methods: {
    retryUpload(id) {
      this.$store.dispatch('retryPhotoUpload', id);
    },
    retryAllErrors() {
      this.errorUploads.forEach(upload => {
        this.retryUpload(upload.id);
      });
    },
    removeUpload(id) {
      this.$store.dispatch('removePhotoFromQueue', id);
    }
  }
};
</script>

<style scoped>
.upload-status-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.2);
}

.upload-details {
  max-height: 200px;
  overflow-y: auto;
}

.progress-xs {
  height: 4px;
  margin-bottom: 0;
}

/* Adjust footer margin when bar is present */
.footer {
  margin-bottom: 0;
}
</style>
